<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Signature</h1>
        </template>

        <div v-if="loaded">
            <p class="" v-if="is_upgraded">🎉 Hurray! You already are using your ambassador signature!</p>
            <p class="" v-else>Your new signature will look like this –</p>
            
            <div class="my-4 p-4 pt-10 text-xs border-l border-r border-b border-gray-darker rounded-b-md">
                <div v-html="current" v-if="current !== null"></div>
                <div v-html="upgrade" v-if="upgrade !== null && !is_upgraded"></div>
            </div>
            
            <p class="mt-6 text-gray-darker text-sm">If you ever change your mind, you can always remove the link from your signature directly from Gmail.</p>

            
        </div>
        <div v-else>
            <loading/>
        </div>

        <template v-slot:footer>
                <progressable-button 
                    type="submit"
                    class="py-2 px-4 rounded-md bg-primary text-white"
                    :state="'Upgrading...'"
                    :loading="upgrading"
                    @click.native="upgradeSignature"
                    v-if="loaded && !is_upgraded">
                    Upgrade my email signature
                </progressable-button>
            </template>
    </modal-component>
</template>

<script>
import ProgressableButton from '../ProgressableButton.vue';
export default {
  components: { ProgressableButton },
    data() {
        return {
            loaded     : false,
            current    : null,
            upgrade    : null,
            upgrading  : false,
            is_upgraded: false,
        }
    },
    mounted() {
        this.loadExistingSignature();
    },
    methods: {
        loadExistingSignature() {
            axios.get('/api/ambassador/tools/signature')
                .then(response => {
                    if (response.data.has_signature) {
                        this.current = response.data.signature;
                    }
                    this.upgrade     = response.data.upgrade;
                    this.is_upgraded = response.data.is_upgraded;
                    this.loaded      = true;
                })
                .catch(console.error);
        },
        upgradeSignature() {
            this.upgrading = true;
            axios.put('/api/ambassador/tools/signature')
                .then(response => {
                    this.$emit('resolve')
                })
                .catch(console.error)
                .finally(() => {
                    this.upgrading = false;
                });
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>